<cm-step-icon [statusColor]="stepStatusColor" [stepType]="data.step_type_id" class="step-icon"></cm-step-icon>
<cm-rejected-hint
    *ngIf="data?.rejectStepData && data.rejectStepData.isRejected"
    [rejectStepData]="data?.rejectStepData"
    [id]="data.step_instance_id"
    [type]="REJECT_HINT_TYPES.STEP"
    [onlyIcon]="data?.content?.responsibleToComplete === LOG_STEP_RESPONSIBLE_TO_COMPLETE.SUPERVISOR"
    class="rejected-hint"
>
</cm-rejected-hint>
